module.exports = __webpack_public_path__ + "static/img/left-bottom-row-3.ac540a30.png";